import * as React from 'react';
export var ArrowLeftCircle = function ArrowLeftCircle(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", {
    transform: "translate(870 213.001)"
  }, React.createElement("path", {
    d: "M-852.4-191.1l9.4-10l-2.8-3l-14.3,15.2l14.2,15.2l2.8-3l-9.4-10h20.5v-4.3L-852.4-191.1z"
  }), React.createElement("path", {
    d: "M-870-189c0,13.3,10.7,24,24,24s24-10.7,24-24s-10.7-24-24-24S-870-202.3-870-189z M-865.8-189\n      c0-10.9,8.9-19.8,19.8-19.8c10.9,0,19.8,8.9,19.8,19.8c0,10.9-8.9,19.8-19.8,19.8C-856.9-169.2-865.8-178.1-865.8-189z"
  })));
};